import { useRef } from 'react';

import Card from 'components/card/Card';
import DatesMore from 'components/dates-more/DatesMore';
import DataTagList from 'components/data-tag-list/DataTagList';
import Heading from 'components/heading/Heading';

import { IEventListItem } from 'source/NFR.types';

const EventListItem: React.FC<IEventListItem> = ({ eventCard, moreDates, date }) => {
  const dateTextRef = useRef<HTMLTimeElement>(null);

  return (
    <div className="event-list-item">
      <Card {...eventCard} isEvent />
      <div className="event-list-item__info-section">
        <div className="card-info-desktop">
          {eventCard.preTitle && (
            <div className="card--date">
              <span className="card--date-dot" />
              <time dateTime={eventCard.preTitle} className="card--date-text">
                {eventCard.preTitle}
              </time>
            </div>
          )}

          {eventCard.title && (
            <a className="card--title" href={eventCard.link?.url}>
              <Heading level={2}>{eventCard.title}</Heading>
            </a>
          )}

          {eventCard.dataTagList && <DataTagList list={eventCard.dataTagList} />}

          {eventCard.text && <p className="card--text">{eventCard.text}</p>}
        </div>
        <div className="date-section">
          {date && (
            <time className="event-card-list--date" ref={dateTextRef} dateTime={date}>
              {date}
            </time>
          )}

          {moreDates && <DatesMore className="event-list-item--dates-more" {...moreDates} />}
        </div>
      </div>
    </div>
  );
};

EventListItem.displayName = 'EventListItem';

export default EventListItem;
